import axios from 'axios'
import DATA from '@/services/static-data'
// import store from '../store'
const baseURL = DATA.KIOSK_VAR.BASE_SERVER_KIOSK
const instance = axios.create({
  baseURL
})

instance.interceptors.request.use(config => {
  console.log(new Date(), '[API request]')
  return config
}, (error) => {
  return Promise.reject(error)
})

instance.interceptors.response.use((response) => {
  console.log(new Date(), '[API response]')
  return response
}, (error) => {
  return Promise.reject(error)
})

export default instance
